import { render, staticRenderFns } from "./syslog.vue?vue&type=template&id=3860f2a8&scoped=true&"
import script from "./syslog.vue?vue&type=script&lang=js&"
export * from "./syslog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3860f2a8",
  null
  
)

export default component.exports